import { useMemo, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput } from '../forms';
import {
  projectActions,
  ProjectStore,
} from '../../../permissions/store/projectStore';

type ProjectSelectorProps = Omit<ComponentProps<typeof SelectInput>, 'value' | 'defaultValue' | 'onChange'> & {
  name?: string,
  /** Показывать удалённые проекты (с deletedDate). */
  showDeleted?: boolean,
  /** Исключить проекты с этими id. */
  excludedValues?: Array<string | number>,
  onChange?: (event: any) => void,
  /** из inject('projectStore') */
  projectStore?: ProjectStore,
};

const ProjectSelector = (props: ProjectSelectorProps) => {
  const {
    name = 'serviceId',
    projectStore,
    showDeleted,
    excludedValues,
    onChange,
    ...rest
  } = props;

  const { projects, loadingProjects } = projectStore;

  // Мемоизированная фильтрация — стабильная ссылка массива для data между рендерами
  const filteredData = useMemo(() => {
    const filteredProjects = projects.filter(v => (!(excludedValues ?? []).includes(v.id)));

    return showDeleted
      ? filteredProjects
      : filteredProjects.filter(v => !v.deletedDate);
  }, [excludedValues, projects, showDeleted]);

  useComponentDidMount(() => {
    // гейт load-once живёт в сторе: повторные mount'ы не дублируют запрос
    projectActions.getProjects();
  });

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ filteredData }
      dataTitle='name'
      dataValue='id'
      loading={ loadingProjects }
      sort
      onChange={ onChange }
    />
  );
};

export default inject('projectStore')(observer(ProjectSelector));
